@if (!creating) {
  <div class="container pb-4 pt-4 pe-0 ps-0 pe-md-2 ps-md-2">
    <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
    currentRouteName="Déposer un ticket"></app-breadcrumb>
    <div class="block-shadow ps-2 pe-2 ps-md-4 pe-md-4 mt-3 pb-4 mb-4 bg-white">
      <h1 class="pt-4">Dépôt d'un ticket</h1>
      <div class="alert alert-info col-md-6">
        <fa-icon icon="info-circle"></fa-icon>
        Pour consulter la FAQ cliquez <a class="link" routerLink="/faq">ici</a>
      </div>
      @if (form) {
        <form [formGroup]="form">
          <app-dynamic-form [(form)]="form" [questions]="questions"></app-dynamic-form>
          <app-upload-file [(sendedFiles)]="sendedFiles"></app-upload-file>
          <div class="mt-3 justify-content-between justify-content-md-end d-flex">
            <app-cancel-button class="me-3" routerLink="/tickets"></app-cancel-button>
            <button type="submit" class="btn btn-primary" [disabled]="form.invalid || sendedFilesNotFinished()" (click)="sendForm()">
              <fa-icon icon="paper-plane" class="d-none d-md-inline-block"></fa-icon>&nbsp;Déposer le ticket
            </button>
          </div>
        </form>
      }
    </div>
  </div>
} @else {
  @if (!error) {
    <div class="pt-5">
      <div class="container text-info pb-5 text-center">
        Dépôt du ticket en cours, merci de ne pas fermer cette fenêtre
      </div>
      <ls-spinner/>
    </div>
  } @else {
    <div class="container pb-4 pt-4 pe-0 ps-0 pe-md-2 ps-md-2">
      <app-breadcrumb [previousRoute]="{name:'Mes tickets d\'assistance', route:'/tickets'}"
      currentRouteName="Déposer un ticket"></app-breadcrumb>
      <div class="block-shadow ps-2 pe-2 ps-md-4 pe-md-4 mt-3 pb-4 mb-4 bg-white">
        <h1 class="pt-4">Dépôt d'un ticket</h1>
        <div class="alert alert-danger col-md-6">
          <fa-icon icon="exclamation-triangle"></fa-icon>
          Impossible de créer le ticket, merci de changer des éléments du formulaire
        </div>
        <button class="btn btn-outline-primary" (click)="creating = false; error = false;">
          Retour
        </button>
      </div>
    </div>
  }
}



